var map = {
	"./en/contact.json": 46531,
	"./en/hero.json": 22547,
	"./en/main.json": 59014,
	"./hr/contact.json": 52970,
	"./hr/hero.json": 89684,
	"./hr/main.json": 79009
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1855;
module.exports = webpackAsyncContext;